export default {
  'menu.overview': '總覽',
  'menu.fund': '基金',
  'menu.fund.list': '基金列表',
  'menu.fund.formation': '新設審批',
  'menu.fund.formationDetail': '新設詳情',
  'menu.fund.detail': '基金詳情',
  'menu.fundraising': '募資跟進',
  'menu.fundraising.board': '募資看板',
  'menu.fundraising.opportunities': '出資人機會',
  'menu.fundraising.opportunityDetail': '機會詳情',
  'menu.lpAndContact': '出資人與聯絡人',
  'menu.lpAndContact.lp': '出資人機構',
  'menu.lpAndContact.contact': '聯絡人',
  'menu.contribution': '繳款與到帳',
  'menu.setting': '設定',
  'menu.setting.dictionary': '業務字典',
  'menu.setting.permissions': '權限管理',
  'menu.setting.modelSettings': '模型設定',
  'menu.login': '登入',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.logout': '登出',
};
